export class ApiRoutesConfig {
  public login = '/auth/login';
  public forgotPassword = '/auth/forgot-password';
  public resetPassword = '/auth/reset-password';
  public registration = '/auth/register';
  public authCheckLogin = '/auth/check-login';
  public self = '/users/self';
  public dashboardUsersAll = '/dashboard/users/all';
  public dashboardUser = '/dashboard/user';
  public dashboardTotalFee = '/dashboard/total-fee';
  public referrals = '/referrals';
  public logout = '/auth/logout';
  public refresh = '/auth/refresh';
  public confirmEmail = '/auth/email-confirm';
  public emailConfirmInit = '/auth/email-confirm-init';
  public gamesCreate = '/games/create';
  public gamesUpdate = '/games/update';
  public gamesLast = '/games/last';
  public gamesUser = '/games/user';
  public transactionsBalanceTransfer = '/transactions/balance-transfer';
  public transactionsAllTransfers = '/transactions/all-transfers';
  public transactionsBalanceWitdrawal = '/transactions/balance-witdrawal';
  public messagesSend = '/messages/send';
  public news = '/news';
  public newsHome = '/news/home';
  public newsAll = '/news/all';
}

const apiRoutes = new ApiRoutesConfig();
export default apiRoutes;
